import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient,HttpHeaders,HttpEvent} from '@angular/common/http';
import {Observable} from 'rxjs';
import {GetParams, GetResponse, Partner, PartnerCreate, PartnerType, PostResponse, User, UserCreate} from '@app/shared';
import {convertGetParamsToHttpParams} from '@app/core';

@Injectable({
  providedIn: 'root'
})
export class PartnerService {

  /** URLs principales relacionadas con Partners **/
  partnerUrl = environment.coreApiBaseUrl + '/api/partner';
  partnerTypeUrl = environment.coreApiBaseUrl + '/api/partner-type';
  userUrl = environment.identityApiBaseUrl + '/api/user';

  constructor(private http: HttpClient) {}

  /** Metodos de obtener/crear/actualizar/eliminar Partners **/
  getPartner(getParams: GetParams, accessToken?: string): Observable<GetResponse> {
    let headers = new HttpHeaders();

    // Si el accessToken es proporcionado, agregamos el header Authorization
    if (accessToken) {
      headers = headers.set('Authorization', `Bearer ${accessToken}`);
    }

    // Realizamos la petición GET con los parámetros y, si es necesario, con el token de autorización
    return this.http.get<GetResponse>(this.partnerUrl, {
      params: convertGetParamsToHttpParams(getParams),
      headers: headers  // Pasamos los headers
    });
  }


  createPartner(newPartner: FormData): Observable<PostResponse> {
    const headers = new HttpHeaders({ enctype: 'multipart/form-data' });
    return this.http.post<PostResponse>(this.partnerUrl, newPartner, {
      headers});
  }

  updatePartner(partner: FormData): Observable<any> {
    const headers = new HttpHeaders({ enctype: 'multipart/form-data' });
    return this.http.put(this.partnerUrl, partner, {headers,});
  }

  deletePartner(partnersIds: number[]): Observable<any> {
    return this.http.delete(this.partnerUrl, {body: {ids: partnersIds}});
  }

  /** Metodos de obtener/crear/actualizar/eliminar PartnerTypes **/
  getPartnerType(getParams: GetParams): Observable<GetResponse> {
    return this.http.get<GetResponse>(this.partnerTypeUrl, {params: convertGetParamsToHttpParams(getParams)});
  }

  createPartnerType(newPartnerType: {name: string, isActive: boolean}): Observable<PostResponse> {
    return this.http.post<PostResponse>(this.partnerTypeUrl, newPartnerType);
  }

  updatePartnerType(partnerType: PartnerType): Observable<any> {
    return this.http.put(this.partnerTypeUrl, partnerType);
  }

  deletePartnerType(partnerTypesIds: number[]): Observable<any> {
    return this.http.delete(this.partnerTypeUrl, {body: {ids: partnerTypesIds}});
  }

  /** Metodos de obtener/crear/actualizar/eliminar User **/
  getUser(getParams: GetParams): Observable<GetResponse> {
    return this.http.get<GetResponse>(this.userUrl, {params: convertGetParamsToHttpParams(getParams)});
  }

  createUser(newUser: UserCreate): Observable<PostResponse> {
    return this.http.post<PostResponse>(this.userUrl, newUser);
  }

  updateUser(User: User): Observable<any> {
    return this.http.put(this.userUrl, User);
  }

  deleteUser(desconsolidationsTypeIds: number[]): Observable<any> {
    return this.http.delete(this.userUrl, {body: {ids: desconsolidationsTypeIds}});
  }


}
